import {
  BayLcgVcgTcgAndPairings,
  IBayPattern,
} from "@tedivo/tedivo-bay-grid-pure";

import { ForeAftEnum } from "open-vessel-definition";

/** Gets the CG at the AFT or FWD of the composed/single bay
 * @param idRef The composed/single bay id
 * @param posRef The position to get the CG that we want to obtain
 * @param lcgVcgTcgAndPairings The calculated LCGs, VCGs and TCGs
 */
export function findReferenceLcg(
  idRef: string,
  posRef: ForeAftEnum,
  lcgVcgTcgAndPairings: BayLcgVcgTcgAndPairings,
) {
  const idParts = idRef.split("-");
  const [bayRefDir, bayRefPair] = idParts as IBayPattern[];

  const { lcgsBy20Bay } = lcgVcgTcgAndPairings;

  // Use ?? (not ||) so an LCG of 0 is not treated as missing
  if (posRef === ForeAftEnum.AFT) {
    return Math.min(
      lcgsBy20Bay[bayRefDir]?.minAftLcg ?? Infinity,
      lcgsBy20Bay[bayRefPair]?.minAftLcg ?? Infinity,
    );
  } else {
    return Math.max(
      lcgsBy20Bay[bayRefDir]?.maxForeLcg ?? -Infinity,
      lcgsBy20Bay[bayRefPair]?.maxForeLcg ?? -Infinity,
    );
  }
}

/** True if the composed/single bay has LCGs (empty bays don't, so they take no space) */
export function bayHasLcgs(
  idRef: string,
  lcgVcgTcgAndPairings: BayLcgVcgTcgAndPairings,
) {
  return (
    Number.isFinite(
      findReferenceLcg(idRef, ForeAftEnum.AFT, lcgVcgTcgAndPairings),
    ) &&
    Number.isFinite(
      findReferenceLcg(idRef, ForeAftEnum.FWD, lcgVcgTcgAndPairings),
    )
  );
}
